import { useIsBelow } from "./useBreakpoint";

export const useHoverTip = (breakpoint: number) =>
  useIsBelow(breakpoint) ? undefined : "global-tip";
